// extracted by mini-css-extract-plugin
export default {"root":"SegmentedControl_root__UjJ39","label":"SegmentedControl_label__yhDW1"};